import { VTextField } from 'vuetify/components'
import { formatDateTimeStringDateOnly } from '~/cynqueModules/utils/formatDateTimeStringDateOnly'

// blurredFormat uses the pure formatDateTimeStringDateOnly (was
// window.$nuxt.$formatDateTimeStringDateOnly, which Nuxt 4 removed). That read
// was UNGUARDED, unlike the optional-chained ones elsewhere, so it threw on
// blur. Same repoint the siblings DateTimeDisplayTimeOnlyVTextField and
// TimeVTextField already carry; this file was missed in that pass.
export default {
  /* eslint-disable no-console */
  extends: VTextField,
  data: () => ({
    mn: '[components/DateTimeDisplayDateOnlyVTextField.js]',
    inputValue: null,
  }),
  props: {
    blurredFormat: {
      type: Function,
      default: (v) => {
        if (v) return formatDateTimeStringDateOnly(v)
      },
    },
  },
  methods: {
    showValue() {
      const fn = `${this.mn} showValue |`
      console.debug(`${fn} lv: ${this.lazyValue}, iv: ${this.initialValue}`)
      if (!this.isFocused) {
        this.inputValue = this.lazyValue
        this.lazyValue = this.blurredFormat(this.lazyValue)
      } else {
        this.lazyValue = this.inputValue
      }
    },
  },
  watch: {
    value() {
      // Handle v-model updates
      if (!this.isFocused) {
        this.showValue()
      }
    },
  },
  mounted() {
    this.showValue()
  },
}
